enum DocumentDictionary {
  NAME = 'Document Type',
  TYPE = 'document-type',
}

export default DocumentDictionary;
